import React from "react";
import styled from "styled-components";

const ProductTag = styled.button`
	padding: ${(props) => (props.small ? "4px 16px" : " 8px 24px")};
	border: none;
	outline: none;
	position: relative;
	z-index: 1;
	border-radius: 20px;
	background: linear-gradient(91.12deg, #03045e 17.08%, #00779d 80.4%);

	&::before {
		content: "";
		position: absolute;
		left: 1px;
		right: 1px;
		top: 1px;
		bottom: 1px;
		border-radius: 19px;
		background-color: white;
		z-index: -1;
	}

	&::after {
		content: attr(data);
		font-size: 14px;
		line-height: 17px;
		background: linear-gradient(91.12deg, #03045e 17.08%, #00779d 80.4%);
		background-clip: text;
		-webkit-background-clip: text;
		color: transparent;
	}
`;

function GradientTag({ text, small }) {
	return <ProductTag small={small} data={text}></ProductTag>;
}

export default GradientTag;
